import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Browse from "@/pages/Browse";
import WorkDetail from "@/pages/WorkDetail";
import Vault from "@/pages/Vault";
import CharacterDetail from "@/pages/CharacterDetail";
import Auth from "@/pages/Auth";
import AuthCallback from "@/pages/AuthCallback";
import Onboarding from "@/pages/Onboarding";
import Dashboard from "@/pages/Dashboard";
import Author from "@/pages/Author";
import Policy from "@/pages/Policy";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";

const TOAST_OPTIONS = {
  style: {
    background: "#161412",
    border: "1px solid rgba(217,180,114,0.25)",
    color: "#F7F3EC",
    fontFamily: "'JetBrains Mono', monospace",
    fontSize: "13px",
  },
};

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function AppRouter() {
  const location = useLocation();
  // Emergent Auth returns to /#session_id=... — intercept before normal routes render
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/browse" element={<Browse />} />
      <Route path="/vault" element={<Vault />} />
      <Route path="/work/:id" element={<WorkDetail />} />
      <Route path="/character/:id" element={<CharacterDetail />} />
      <Route path="/auth" element={<Auth />} />
      <Route path="/onboarding" element={<Onboarding />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/author/:pseudonym" element={<Author />} />
      <Route path="/policy" element={<Policy />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
        <Toaster theme="dark" position="top-center" toastOptions={TOAST_OPTIONS} />
      </AuthProvider>
    </div>
  );
}

export default App;
